module.exports = "/images/vendor/flag-icon-css/flags/1x1/ma.svg?bee9c05416fd66f6bc4434f6d721bcac";